import { render } from "./BackGround.vue?vue&type=template&id=c0657bd0&scoped=true"
const script = {}

import "./BackGround.vue?vue&type=style&index=0&id=c0657bd0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c0657bd0"

export default script